import {
  MenuItemStatusSchema,
  type MenuItemStatus as GeneratedMenuItemStatus
} from '~/services/api/generated'

export type MenuItemStatus = GeneratedMenuItemStatus

export const MenuItemStatus = {
  DRAFT: MenuItemStatusSchema.enum.draft,
  PUBLISHED: MenuItemStatusSchema.enum.published
}

export const MenuItemStatusValues = [
  MenuItemStatusSchema.enum.draft,
  MenuItemStatusSchema.enum.published
]
